<template>
  <div class="aroma-shop aroma-primary-page">
    <header class="aroma-page-header">
      <h1>商城</h1>
      <p>精选助眠产品</p>
    </header>

    <main class="aroma-shop__content">
      <div v-if="loading" class="aroma-page-state">
        <van-loading size="28px">加载中...</van-loading>
      </div>
      <div v-else-if="errorMessage" class="aroma-page-state">
        <van-empty :description="errorMessage">
          <van-button class="aroma-shop__retry" type="primary" size="small" @click="loadProduct">重新加载</van-button>
        </van-empty>
      </div>
      <template v-else-if="products.length">
        <div class="aroma-section-title">商品列表</div>
        <aroma-product-card
          v-for="product in products"
          :key="product.productId"
          :product="product"
          :image="getProductImage(product)"
          class="aroma-shop__product"
          @click="openProduct(product)"
        />
      </template>
    </main>

    <aroma-tabbar />
  </div>
</template>

<script>
import API from '@/api'
import AromaProductCard from '@/components/aroma-report/AromaProductCard.vue'
import AromaTabbar from '@/components/aroma-report/AromaTabbar.vue'
import { AROMA_PRODUCTS } from '@/utils/aroma-shop'
import { applySniCurrentResult, clearAllSniSessions, extractSniProfile, getActiveSniSession, updateSniProfile } from '@/utils/sni-session'

export default {
  name: 'AromaShop',

  components: {
    AromaProductCard,
    AromaTabbar
  },

  data () {
    return {
      loading: false,
      products: [],
      errorMessage: ''
    }
  },

  computed: {
    sn () {
      return this.$route.query.sn || ''
    },

    session () {
      return getActiveSniSession(this.sn)
    }
  },

  mounted () {
    this.loadProduct()
  },

  methods: {
    async loadProduct () {
      this.loading = true
      this.errorMessage = ''
      try {
        const [products, profile] = await Promise.all([
          Promise.all(AROMA_PRODUCTS.map(async config => {
            const response = await API.aromaPackageDetail(config.packageId)
            if (response?.code !== '1' || !response.data) {
              throw new Error(response?.msg || '商品暂不可用')
            }
            return {
              ...response.data,
              productId: config.id,
              packageId: config.packageId,
              taskId: config.taskId,
              catalogName: config.packageName,
              detailImage: config.detailImage || ''
            }
          })),
          API.sniCurrent(this.session.token)
        ])
        this.products = products
        applySniCurrentResult(profile, this.session.token)
        const profileData = extractSniProfile(profile)
        updateSniProfile(profileData, this.sn)
      } catch (error) {
        if (error?.code === '8' || error?.code === '11') {
          this.handleSessionExpired()
          return
        }
        this.errorMessage = error?.message || '商品暂不可用'
      } finally {
        this.loading = false
      }
    },

    getProductImage (product) {
      return product.img
    },

    openProduct (product) {
      if (!product) return
      this.$router.push({
        name: 'AromaProductDetail',
        query: {
          ...(this.sn ? { sn: this.sn } : {}),
          productId: product.productId
        }
      })
    },

    handleSessionExpired () {
      clearAllSniSessions()
      this.$router.replace({
        name: 'AromaReportLogin',
        query: {
          ...(this.sn ? { sn: this.sn } : {}),
          redirect: this.$route.fullPath
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/aroma-commerce.scss';

.aroma-shop {
  &__content {
    padding: 0 12px;
  }

  &__retry {
    background: #596afd;
    border-color: #596afd;
  }

  &__product + &__product {
    margin-top: 12px;
  }
}
</style>
